// extracted by mini-css-extract-plugin
export default {"Box":"row-reorder-sash-module__Box--R_j58","Octicon":"row-reorder-sash-module__Octicon--uWD67"};